import request from '../request';


//(条件)分页查询
export const reqGetPageData = (data) => request({ url:'/admin/orders/page', method:'get', params:data });

//调整订单状态
export const reqUpdateOrderStatus = (status, orderNo) => request({ url:`/admin/orders/orderStatus/${status}/${orderNo}`, method:'post' });

//调整支付状态
export const reqUpdatePayStatus = (status, orderNo) => request({ url:`/admin/orders/payStatus/${status}/${orderNo}`, method:'post' });

//新增菜品
export const reqAddData = (data) => request({ url:'/admin/orders/save', method:'post', data });

//删除菜品
export const reqDeleteData = (id) => request({ url:`/admin/orders/delete/dish/${id}`, method:'delete'});

//后厨任务提醒
export const reqTrigger = (id) => request({ url:`/admin/orders/${id}`, method:'get' });
